import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { STATUS_FORBIDDEN } from "src/app/core/constants/const";
import { LOGOUT_TIMEOUT } from "src/app/core/constants/consts";
import { DalkonValorDevuelto } from "src/app/core/models/dalkon.valor.devuelto";
import { MenuPermissions } from "src/app/core/models/menu.permissions";
import { MessagesPipe } from "src/app/shared/pipes/messages.pipe";
import { AuthenticationService } from "src/app/shared/services/authentication.service";
import { BaseService } from "src/app/shared/services/base.service";
import { DalkonService } from "src/app/shared/services/dalkon.service";
import { FlashMessagesService } from "src/app/shared/services/flash-messages.service";
import { HomeService } from './home.service';

@Component({
  selector: "app-home-parking",
  templateUrl: "./home-parking.component.html",
  styleUrls: ["./home-parking.component.scss"]
})
export class HomeParkingComponent implements OnInit, AfterViewInit {
  @Input() home?: boolean;
  messagesPipe: MessagesPipe;
  parking: DalkonValorDevuelto;
  permissions: MenuPermissions;

  constructor(
    private authenticationService: AuthenticationService,
    private dalkonService: DalkonService,
    private flashMessagesService: FlashMessagesService,
    private baseService: BaseService,
    private homeService: HomeService
  ) {
    this.messagesPipe = new MessagesPipe();
    this.homeService.inicio = this.inicio.bind(this);
  }

  ngOnInit() {
    this.permissions = this.authenticationService.getPermissionsForCurrentUser();
  }

  ngAfterViewInit() {
    if (!this.home) {
      this.inicio();
    }
  }

  inicio() {
    this.loadParking();
  }

  loadParking(): void {
    this.dalkonService
      .obtainData(this.authenticationService.getToken())
      .subscribe(
        response => {
          this.parking = response;
        },
        error => {
          if (error.code == STATUS_FORBIDDEN) {
            this.authenticationService.refreshToken().subscribe(
              response => {
                this.loadParking();
              },
              error => {
                this.authenticationService.validateSessionId().subscribe(
                  response => {
                    this.loadParking();
                  },
                  error => {
                    this.flashMessagesService.grayOut(false);
                    this.flashMessagesService.show(
                      this.messagesPipe.transform("error_forbidden"),
                      { cssClass: "alert-danger", timeout: 3000 }
                    );

                    setTimeout(() => {
                      this.authenticationService.logout();
                    }, LOGOUT_TIMEOUT);
                  }
                );
              }
            );
          } else {
            this.baseService.showErrorDialog(
              this.flashMessagesService,
              error,
              this.messagesPipe.transform("error_dalkonParking")
            );
          }
        }
      );
  }
}
